import { FaceWomanShimmerOutlineIcon } from './FaceWomanShimmerOutlineIcon';

/**
 * author: Simran
 * id 43851D4C-D310-45C3-9A86-6BF5DFD51055
 * name face-woman-shimmer-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-woman-shimmer-outline.svg
 * tags
 * - People / Family 
 * - Photography 
 * - Health / Beauty 
 * - Account / User 
 */
export const EmoticonWomanShimmerOutlineIcon = FaceWomanShimmerOutlineIcon;
export default EmoticonWomanShimmerOutlineIcon